<template>
<router-view/>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style>
@import "./assets/css/common.css";
</style>



// WEBPACK FOOTER //
// src/App.vue